import './utils/polyfill'
import 'babel-polyfill'
import 'what-input'
import 'whatwg-fetch'
import './variables/icons'

import Vue from 'vue'
import sv from 'vee-validate/dist/locale/sv'
import VeeValidate, { Validator } from 'vee-validate'
import App from './App'
import router from './router'
import store from './store/store'
import * as types from '@/store/actionTypes'

import { Hermes } from 'apollo-cache-hermes'
import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
import { setContext } from 'apollo-link-context'
import { onError } from 'apollo-link-error'
import { HttpLink } from 'apollo-link-http'
import VueApollo from 'vue-apollo'
import Paginate from 'vuejs-paginate'
import VueScrollTo from 'vue-scrollto'
import PortalVue from 'portal-vue'
import Icon from 'vue-awesome/components/Icon'
import cookieUtils from '@/utils/cookies'
import { deconstructJWT } from '@/utils/helpers'
import { requiredFields } from '@/utils/requiredFields'

const logOut = () => {
  store.commit(types.LOG_OUT)
  router.push('/')
}

export const handleErrors = ({ graphQLErrors }) => {
  const token = cookieUtils.getItem('search-token')

  if (graphQLErrors.length > 0 && !token) {
    logOut()
  }
}

export const authLink = setContext((root, { headers }) => {
  const token = cookieUtils.getItem('search-token')

  // Redirect to login if no token
  if (!token) {
    return { headers }
  }

  // Check if token has expired
  const tokenExpires = deconstructJWT(token).exp

  if (Date.now() - tokenExpires * 1000 > 0) {
    cookieUtils.removeItem('search-token')
    logOut()

    return { headers }
  }

  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : ''
    }
  }
})

const httpLink = new HttpLink({
  uri: `${__API_URL__}graphql`
})

const link = ApolloLink.from([onError(handleErrors), authLink, httpLink])

const apolloClient = new ApolloClient({
  cache: new Hermes({
    entityIdForNode: r => {
      if (r.path && r.__typename) {
        return `${r.__typename}:${r.path}`
      }

      if (r.id && r.__typename) {
        return `${r.__typename}:${r.id}`
      }

      return r.id
    },
    addTypename: true
  }),
  link: link,
  connectToDevTools: true
})

export const swedish = {
  ...sv,
  messages: {
    ...sv.messages,
    email: 'Ogiltig mejladress',
    required: requiredFields
  }
}

Validator.localize('sv', swedish)

Vue.use(VeeValidate, {
  events: 'blur'
})
Vue.use(VueApollo)
Vue.use(VueScrollTo)
Vue.use(PortalVue)
Vue.component('AwesomeIcon', Icon)

Vue.component('paginate', Paginate)

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

Vue.config.productionTip = false

window.eventBus = new Vue({})

/* eslint-disable no-new */
new Vue({
  apolloProvider,
  router,
  store,
  el: '#app',
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js